import React, { FC, useEffect, useLayoutEffect, useState } from "react";
import classes from "./Login.module.scss";
import logo from "../../../assets/logo.png";
import google from "../../../assets/google.png";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { loadingState, loadingText } from "../../../states/loadingState";
import { ErrorModal } from "../../uikit/modal/ErrorModal";
import { useLogin } from "../../../hooks/useLogin";
import SwitchMode from "../../uikit/atoms/SwitchMode";
import { userState } from "../../../states/userState";
import {
  backgroundColor,
  backgroundColorLoginDesc,
  foreColor,
  foreColorLoginDesc,
} from "../../../commons/colors";

const Login: FC = () => {
  const navigation = useNavigate();

  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const user = useRecoilValue(userState);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("ログインエラー");
  const [message, setMessage] = useState("Google認証に失敗しました");
  const [isShowErrorDialog, setIsShowErrorDialog] = useState(false);
  const { loginWithGoogle, error } = useLogin();
  const onClickLogin = async () => {
    //ローディング表示
    //画面
    setLoadingAnimation(true);
    setLoadingText("認証中...");
    //ボタン
    setLoading(true);
    try {
      const isSuccess = await loginWithGoogle();
      navigation("/");
    } catch (error) {
      //モーダル表示
      setMessage("Google認証に失敗しました");
      setIsShowErrorDialog(true);
    } finally {
      setLoading(false);
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };
  useEffect(() => {
    if (user?.isAuth) {
      navigation("/");
    }
  }, [user, navigation]);

  const ImageIcon = () => {
    return (
      <img
        src={google}
        alt="Login"
        style={{ width: 32, height: 24, paddingRight: 10 }}
      />
    );
  };
  return (
    <>
      <div
        className={classes.login}
        style={backgroundColorLoginDesc(user?.mode ?? "dark")}
      >
        <div className={classes.loginWrapper}>
          <div className={classes.loginLeft}>
            <h3 className={classes.loginTitle}>ProcessVISION</h3>
            <span
              className={classes.loginDesc}
              style={foreColorLoginDesc(user?.mode ?? "dark")}
            >
              製造プロセス可視化
            </span>
          </div>
          <div className={classes.loginRight}>
            <div
              className={
                user?.mode === "lite" ? classes.loginBoxLight : classes.loginBox
              }
            >
              <div className={classes.switch}>
                <SwitchMode />
              </div>
              <div className={classes.loginLogo}>
                <img src={logo} alt="" />
              </div>
              <LoadingButton
                onClick={onClickLogin}
                loadingPosition="start"
                startIcon={<ImageIcon />}
                loading={loading}
                variant="contained"
                sx={{ boxShadow: "7px 10px 13px -10px #0d0e11" }}
              >
                ログイン
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
      {isShowErrorDialog && (
        <ErrorModal
          title={title}
          message={message}
          setIsShow={setIsShowErrorDialog}
        />
      )}
    </>
  );
};

export default Login;
